import { render } from "./AddStaff.vue?vue&type=template&id=4999256f&scoped=true&ts=true"
import script from "./AddStaff.vue?vue&type=script&lang=ts"
export * from "./AddStaff.vue?vue&type=script&lang=ts"

import "./AddStaff.vue?vue&type=style&index=0&id=4999256f&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4999256f"]])

export default __exports__